import axios from "axios";

export default () => {
  const tokenDom = document.querySelector("meta[name=csrf-token]");
  axios.defaults.headers.common.Accept = "application/json";
  axios.defaults.headers.common["Content-Type"] = "application/json";
  axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
  if (tokenDom) {
    const csrfToken = tokenDom.content;
    axios.defaults.headers.common["X-CSRF-Token"] = csrfToken;
  }
};
